export default [
  '#FFF',
  '#C1C1C1',
  '#EF130B',
  '#FF7100',
  '#FFE400',
  '#00CC00',
  '#00B2FF',
  '#231FD3',
  '#A300BA',
  '#D37CAA',
  '#A0522D',
  '#000',
  '#4C4C4C',
  '#740B07',
  '#C23800',
  '#E8A200',
  '#005510',
  '#00569E',
  '#0E0865',
  '#550069',
  '#A75574',
  '#63300D'
];
